<template>
  <button
    type="button"
    class="toggle-button"
    :class="{on: !!value, [`${onColor} bg`]: !!value, [`${offColor} bg`]: !value, disabled}"
    :disabled="disabled"
    @click="toggle"
  >
    <md-icon :class="`${iconColor} color`">{{ icon }}</md-icon>
    <slot />
  </button>
</template>

<script>
export default {
  name: 'toggle-button',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'power_settings_new',
    },
    offColor: {
      type: String,
      default: 'gray-4',
    },
    onColor: {
      type: String,
      default: 'green-4',
    },
    iconColor: {
      type: String,
      default: 'white',
    },
  },
  methods: {
    toggle() {
      this.$emit('toggle', !this.value);
      this.$emit('input', !this.value);
    },
  },
};
</script>

<style scoped>
.toggle-button {
  border: none;
  border-radius: 5px;
  cursor: pointer;
  /* box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.75); */
}

.toggle-button.disabled:not(.on) {
  background-color: #5D5D5D !important;
}

.toggle-button.disabled {
  cursor: not-allowed;
}

.toggle-button.disabled .md-icon {
  color: #000000 !important;
}
</style>